<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-4"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="session">

        <div class="display-3 text-white mb-4">
            <span class="text-muted d-inline">{{ registration.degree.name }} /</span>
            {{ simulation.name }}
        </div>

        <div class="row mb-4">
            <div class="col-md-6 text-center pb-2">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-calendar-alt"></i>
                </span>
                <span class="pl-2 text-sm text-white">
                    {{ date }}
                </span>
            </div>
            <div class="col-md-6 text-center pb-2">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-calendar-alt"></i>
                </span>
                <span class="pl-2 text-sm text-white">
                    <span class="text-muted">{{ $t('common.from') }}</span> {{ from }}
                    <span class="text-muted">{{ $t('common.to').toLowerCase() }}</span> {{ to }}
                </span>
            </div>
        </div>

        <div class="mb-2" v-if="$permissions.hasRight('dashboard.learners.write')">

            <base-button type="warning" @click="openSessionLog" v-if="activeSession && !session.ended_at">
                <i class="fas fa-play mr-1"></i> {{ $t('common.log') }}
            </base-button>

            <base-button type="secondary" @click="openSessionLog" v-if="activeSession && session.ended_at">
                <i class="fas fa-play mr-1"></i> {{ $t('common.log') }}
            </base-button>

            <base-button type="secondary" @click="openLog" v-if="!activeSession && !simulation.remedial">
                {{ $t('common.log') }}
            </base-button>

            <base-button type="secondary" @click="openSharedFeedbacks" v-if="!simulation.remedial">
                {{ $t('feedbacks.shared-feedbacks') }}
                <span class="pl-1" v-if="sharedFeedbacks">
                    ({{ sharedFeedbacks.count }})
                </span>
            </base-button>
        </div>

        <portal to="modals" v-if="$permissions.hasRight('dashboard.shared-feedbacks.read')">
            <base-modal size="lg"
                v-model="modals.sharedFeedbacks"
                :title="$t('feedbacks.shared-feedbacks')"
                body-classes="py-0"
            >
                <shared-feedbacks :registration="registration" :simulation="simulation"
                    :modal="modals.sharedFeedbacks" :competencies="competencies">
                </shared-feedbacks>
            </base-modal>
        </portal>
    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import SharedFeedbacks from '../common/SharedFeedbacks'
    import moment from 'moment'

    export default {

        components: {
            SharedFeedbacks
        },

        props: {
            
            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },
            
            session: {
                type: Object,
                required: true
            },

            groups: {
                type: Array,
                required: true
            },

            competencies: {
                type: Array,
                default: []
            },
        },

        data() {
            return {
                modals: new ModalsController('sharedFeedbacks'),
                moment: moment,
                sharedFeedbacks: null
            }
        },

        computed: {

            activeSession() {
                return this.session.instructor.id == this.$auth.user.id && !this.session.closed_at
            },

            date() {
                let date = this.session.started_at ? this.session.started_at : this.session.created_at
                return this.moment(date).format('YYYY/MM/DD')
            },
            
            from() {
                if (!this.session.started_at) {
                    return '-'
                }
                return this.moment(this.session.started_at).format('HH:MM')
            },
            
            to() {
                if (!this.session.ended_at) {
                    return '-'
                }
                return this.moment(this.session.ended_at).format('HH:MM')
            },
        },

        methods: {

            setSharedFeedbacks(sharedFeedbacks) {
                this.sharedFeedbacks = sharedFeedbacks
            },

            openSharedFeedbacks() {
                this.modals.open('sharedFeedbacks')
            },

            openLog() {
                this.$router.push({
                    name: 'log',
                    params: {
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        groupId: this.groups.length ? this.groups[0].id : 0,
                    }
                });
            },

            openSessionLog() {
                this.$router.push({ name: 'log-session',
                    params: { 
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        sessionId: this.session.id,
                        groupId: 0,
                    }
                })
            },
        }
    }
</script>
